import * as z$1 from "zod/v4";
//#region src/schemas/daemon/route-observation-summary.ts
const DAEMON_ROUTE_OBSERVATION_STATUS_VALUES = [
	"online",
	"offline",
	"unavailable"
];
const DAEMON_ROUTE_OBSERVATION_UNAVAILABLE_REASON_CODE_VALUES = [
	"lookup_failed",
	"not_requested",
	"profile_not_agent",
	"profile_not_selected",
	"server_unsupported"
];
const DAEMON_ROUTE_OBSERVATION_REASON_CODE_VALUES = [
	"online",
	"route.not_registered",
	...DAEMON_ROUTE_OBSERVATION_UNAVAILABLE_REASON_CODE_VALUES
];
const daemonRouteObservationStatusSchema = z$1.enum(DAEMON_ROUTE_OBSERVATION_STATUS_VALUES);
const daemonRouteObservationUnavailableReasonCodeSchema = z$1.enum(DAEMON_ROUTE_OBSERVATION_UNAVAILABLE_REASON_CODE_VALUES);
const daemonRouteObservationReasonCodeSchema = z$1.enum(DAEMON_ROUTE_OBSERVATION_REASON_CODE_VALUES);
const CANONICAL_UNAVAILABLE_REASON_CODE_SET = new Set(DAEMON_ROUTE_OBSERVATION_UNAVAILABLE_REASON_CODE_VALUES);
function isCanonicalUnavailableReasonCode(value) {
	return value !== null && value !== void 0 ? CANONICAL_UNAVAILABLE_REASON_CODE_SET.has(value) : false;
}
function createDaemonRouteObservationSummary(input) {
	if (input.status === "online") return {
		observedAt: input.observedAt,
		reasonCode: "online",
		status: "online"
	};
	if (input.status === "offline") return {
		observedAt: input.observedAt,
		reasonCode: "route.not_registered",
		status: "offline"
	};
	return {
		observedAt: input.observedAt,
		reasonCode: isCanonicalUnavailableReasonCode(input.reasonCode) ? input.reasonCode : "lookup_failed",
		status: "unavailable"
	};
}
const daemonRouteObservationSummarySchema = z$1.strictObject({
	observedAt: z$1.iso.datetime({ offset: true }),
	reasonCode: daemonRouteObservationReasonCodeSchema,
	status: daemonRouteObservationStatusSchema
}).superRefine((value, ctx) => {
	if (value.status === "online" && value.reasonCode !== "online") ctx.addIssue({
		code: "custom",
		message: "online route observation must use online reasonCode",
		path: ["reasonCode"]
	});
	if (value.status === "offline" && value.reasonCode !== "route.not_registered") ctx.addIssue({
		code: "custom",
		message: "offline route observation must normalize to route.not_registered",
		path: ["reasonCode"]
	});
	if (value.status === "unavailable" && (value.reasonCode === "online" || value.reasonCode === "route.not_registered")) ctx.addIssue({
		code: "custom",
		message: "unavailable route observation must use an unavailable reasonCode",
		path: ["reasonCode"]
	});
});
//#endregion
export { DAEMON_ROUTE_OBSERVATION_REASON_CODE_VALUES, DAEMON_ROUTE_OBSERVATION_STATUS_VALUES, DAEMON_ROUTE_OBSERVATION_UNAVAILABLE_REASON_CODE_VALUES, createDaemonRouteObservationSummary, daemonRouteObservationReasonCodeSchema, daemonRouteObservationStatusSchema, daemonRouteObservationSummarySchema, daemonRouteObservationUnavailableReasonCodeSchema };

//# sourceMappingURL=route-observation-summary.js.map